import { create } from 'zustand';
import type * as THREE from 'three';

/** 렌더 결과물이 아니라 "보는 방식"에 대한 것들. 파이프라인을 재계산시키지 않는다. */
export type Workspace = 'character' | 'map' | 'terrain' | 'blender';

export interface ViewStore {
  /** 작업대: 캐릭터(기존) · 맵(타일 키트) · 지형(하이트맵) */
  workspace: Workspace;
  setWorkspace: (w: Workspace) => void;
  autoRotate: boolean;
  wireframe: boolean;
  showEnvironment: boolean;
  exposure: number;
  toggle: (key: 'autoRotate' | 'wireframe' | 'showEnvironment') => void;
  setExposure: (v: number) => void;
}

export const useViewStore = create<ViewStore>((set) => ({
  workspace: 'character',
  setWorkspace: (workspace) => set({ workspace }),
  autoRotate: true,
  wireframe: false,
  showEnvironment: true,
  exposure: 1.05,
  toggle: (key) => set((s) => ({ [key]: !s[key] }) as Partial<ViewStore>),
  setExposure: (exposure) => set({ exposure }),
}));

/** 익스포터가 현재 메시를 집어가기 위한 통로. 컨텍스트를 하나 더 만들 만한 일이 아니다. */
export const forgedMeshRef: { current: THREE.SkinnedMesh | null } = { current: null };
/** 뷰어가 채우는 캡처 함수 — 방위 배열을 받아 PNG data URL 을 돌려준다(Meshy 의 4뷰 썸네일). */
export const captureRef: { current: ((azimuths: number[]) => string[]) | null } = { current: null };
